import { render } from "./recent-sold.vue?vue&type=template&id=e5cdc2aa"
import script from "./recent-sold.vue?vue&type=script&lang=js"
export * from "./recent-sold.vue?vue&type=script&lang=js"

import "./recent-sold.vue?vue&type=style&index=0&id=e5cdc2aa&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/search-result/template4/components/recent-sold.vue'],['render',render],['__file',"recent-sold.vue"]])

export default __exports__